// Site
export const SERVICE_NAME = 'National Maritime Single Window';
export const SERVICE_URL = 'https://www.nmsw.homeoffice.gov.uk';
export const SERVICE_CONTACT_EMAIL = 'nmsw@homeoffice.gov.uk'; // update on public/index.html as well
export const UK_BF_CARRIER_SUP_HUB = '0300 369 0610';
export const UK_BF_CARRIER_SUP_HUB_INTNATL = '+44 204 619 6020';

// Cookie preference
export const COOKIEPREF_COOKIE_AGE = 365 * 24 * 60 * 60;

// Interstitial
export const INFO_COOKIE_NAME = 'INFO_VERSION';
export const INFO_VERSION = '1'; // update this to force user to see interstitial on next sign in

// Declarations
export const DECLARATION_STATUS_CANCELLED = 'Cancelled';
export const DECLARATION_STATUS_DRAFT = 'Draft';
export const DECLARATION_STATUS_FAILED = 'Failed';
export const DECLARATION_STATUS_PRECANCELLED = 'PreCancelled';
export const DECLARATION_STATUS_PRESUBMITTED = 'PreSubmitted';
export const DECLARATION_STATUS_SUBMITTED = 'Submitted';

// Declarations statuses groups
export const DECLARATION_STATUS_GROUP_CANCELLED = 'Cancelled';
export const DECLARATION_STATUS_GROUP_DRAFT = 'Draft';
export const DECLARATION_STATUS_GROUP_SUBMITTED = 'Submitted';

// Declaration step statuses
export const DECLARATION_STEP_STATUS_CANNOT_START = 'cannotStartYet';
export const DECLARATION_STEP_STATUS_COMPLETED = 'completed';
export const DECLARATION_STEP_STATUS_NOT_STARTED = 'notStarted';
export const DECLARATION_STEP_STATUS_OPTIONAL = 'optional';

export const DECLARATION_STEP_STATUS_CICOMPLETE = 'ciCompleted';
export const DECLARATION_STEP_STATUS_CIPROCESSING = 'ciProcessing';
export const DECLARATION_STEP_STATUS_ERRORSYSTEM = 'errorSystem';
export const DECLARATION_STEP_STATUS_0T = 'ZeroT';
export const DECLARATION_STEP_STATUS_0T_OUTBOUND = 'outBoundPassengerWithZeroT';
export const DECLARATION_STEP_STATUS_0T_CREW = 'crewWithZeroT';
export const DECLARATION_STEP_STATUS_ERRORUSER = 'errorUser';
export const DECLARATION_STEP_STATUS_DEPARTURECICOMPLETE = 'departureCiComplete';
export const DECLARATION_STEP_STATUS_FINALFILECICOMPLETE = 'finalFileCiComplete';
export const DECLARATION_STEP_STATUS_NOPASSENGERS = 'noPassengers';
export const DECLARATION_STEP_STATUS_NOTFINAL = 'notFinalFile';
export const DECLARATION_STEP_STATUS_REQUIRED = 'required';
export const DECLARATION_STEP_STATUS_ERROR_REST = 'errorRest';

// UPT
/**
 * amgPassengerResponseCount or amgCrewResponseCount on API /declaration response
 * and responseSector on /people response
 * returns these strings
 * we then use them for determining declaration status (can user submit),
 * alert banner -> are there any no boards or check document types
 * So be wary of changing the string here as they must match the api response string!
 */
export const DECLARATION_UPT_STATUS_BOARD = 'Board';
export const DECLARATION_UPT_STATUS_CHECK = 'Check';
export const DECLARATION_UPT_STATUS_OTHER = 'Other';

/** responseDescription on /people response
 * returns these strings & others
 * we use the ones below to add additional explanation text to the UI
 * if there is no additional text on the array in UptPerson
 * then none is shown
 */
export const UPT_RESPONSE_AUTHORITY_GRANTED = 'AUTHORITY TO CARRY GRANTED';
export const UPT_RESPONSE_VALID_PERMISSION = 'VALID PERMISSION TO TRAVEL';
export const UPT_RESPONSE_NO_RECORD = 'NO RECORD OF VALID PERMISSION TO TRAVEL';
export const UPT_RESPONSE_SYSTEM_TIME_OUT = 'SYSTEM TIME OUT';

export const UPT_RESPONSE_AUTHORITY_GRANTED_LABEL = 'Authority to carry granted';
export const UPT_RESPONSE_VALID_PERMISSION_LABEL = 'Valid permission to travel';
export const UPT_RESPONSE_NO_RECORD_LABEL = 'No record of valid permission to travel';
export const UPT_RESPONSE_SYSTEM_TIME_OUT_LABEL = 'System time out';

// UPT Response code and Label mapping
export const STATUS_FILTERS = [
  { value: '', label: 'All results' },
  { value: '0B', label: 'No record of valid permission' },
  { value: '0Z', label: 'Authority to carry granted' },
  { value: '0A', label: 'Valid permission to travel' },
];
export const UPT_RESPONSE_NO_RECORD_RESPONSE_CODE = '0B';
export const UPT_RESPONSE_AUTHORITY_CARRY_GRANTED_CODE = '0Z';
export const UPT_RESPONSE_VALID_PERMISSION_TRAVEL_CODE = '0A';
export const UPT_RESPONSE_SYSTEM_TIME_OUT_CODE = '0T';

// Forms: display types
export const DISPLAY_DETAILS = 'details';
export const DISPLAY_GROUPED = 'grouped';
export const DISPLAY_SINGLE = 'single';
export const DISPLAY_PASSWORD = 'password';

// Forms: identifiers
export const EXPANDED_DETAILS = 'ExpandedDetails';
export const MULTI_PAGE_FORM = 'multiPageForm';
export const PASSWORD_FORM = 'passwordForm';
export const SIGN_IN_FORM = 'signInForm';
export const SINGLE_PAGE_FORM = 'singlePageForm';

// Forms: input types
export const FIELD_AUTOCOMPLETE = 'autocomplete';
export const FIELD_CONDITIONAL = 'conditional';
export const FIELD_CHECKBOX = 'checkbox';
export const FIELD_SELECT = 'select';
export const FIELD_EMAIL = 'email';
export const FIELD_PASSWORD = 'password';
export const FIELD_PHONE = 'tel';
export const FIELD_TEXT = 'text';
export const FIELD_RADIO = 'radio';
export const AUTOCOMPLETE_DIALCODE = 'dialCode';

// Forms: states
export const CHECKED_TRUE = true;
export const CHECKED_FALSE = false;
export const FILE_STATUS_PENDING = 'Pending';
export const FILE_STATUS_IN_PROGRESS = 'in progress';
export const FILE_STATUS_ERROR = 'Error';
export const FILE_STATUS_SUCCESS = 'Success';

// Forms: validation types
export const VALIDATE_CONDITIONAL = 'conditional';
export const VALIDATE_EMAIL_ADDRESS = 'emailAddress';
export const VALIDATE_FIELD_MATCH = 'match'; // not case sensitive e.g. `BaA` and `baa` will be a valid match
export const VALIDATE_FIELD_MATCH_CASE_SENSITIVE = 'matchCaseSensitive'; // e.g. `BaA` and `baa` will fail
export const VALIDATE_MAX_LENGTH = 'maxLength';
export const VALIDATE_MIN_LENGTH = 'minLength';
export const VALIDATE_PHONE_NUMBER = 'phoneNumber';
export const VALIDATE_REQUIRED = 'required';
export const VALIDATE_NO_SPACES = 'noSpaces';

// Forms: error types
export const ERROR_AMG_FOR_CYA_PAGE = 'errorCYAAMG';
export const FAL6_FINAL_FALSE = 'fal6FinalFileFalse';
export const AMG_CI_PROCESSING_CREW = 'amgProcessingCrew';
export const AMG_CI_PROCESSING_PASSENGERS = 'amgProcessingPassengers';
export const FILE_DOWNLOAD_ERROR = 'fileDownloadError';

// Pagination
export const ELLIPSIS = '...';
export const PAGINATION_PAGE_LABEL = 'Page';
export const PAGINATION_PREVIOUS_LABEL = 'Previous';
export const PAGINATION_NEXT_LABEL = 'Next';
export const PAGINATION_DEFAULT_PAGE_START_NUMBER = 0;
export const PAGINATION_DISPLAYABLE_PAGE_NUMBER_INCREMENTOR = 1;
export const PAGINATION_ITEMS_PER_PAGE = 10;

// Labels
export const PASSENGERS_AND_SUPERNUMERARIES_LABEL = 'Is the ship carrying any passengers or supernumeraries?';
export const SUPPORTING_DOCUMENTS_LABEL = 'Supporting documents';

// Page titles
export const PASSENGERS_TITLE = 'Is the ship carrying any passengers?';

// Templates
export const CREW_DETAILS_TEMPLATE_NAME = 'Crew details (FAL 5)';
export const GENERAL_DECLARATION_TEMPLATE_NAME = 'General Declaration (FAL 1)';
export const PASSENGER_DETAILS_TEMPLATE_NAME = 'Passenger details including supernumeraries (FAL 6)';

// File upload
export const MAX_FILE_SIZE = 4194304;
export const MAX_FILE_SIZE_DISPLAY = (MAX_FILE_SIZE / (1024 * 1024)).toFixed(0);
export const MAX_SUPPORTING_FILE_SIZE = 1048576;
export const MAX_SUPPORTING_FILE_SIZE_DISPLAY = (MAX_SUPPORTING_FILE_SIZE / (1024 * 1024)).toFixed(0);
export const MAX_FILES = 8;
export const ALLOWED_SUPPORTING_FILE_EXTENSIONS = ['csv', 'doc', 'docm', 'docx', 'rtf', 'txt', 'xls', 'xlsm', 'xlsx', 'xltm', 'xlw', 'xml'];
export const PEOPLE_TYPE_PASSENGERS = 'Passenger';
export const PEOPLE_TYPE_CREW = 'Crew';
export const FILE_TOO_LARGE_MESSAGE = `The selected file must be smaller than ${MAX_SUPPORTING_FILE_SIZE_DISPLAY}MB`;
export const INVALID_FILETYPE_MESSAGE = 'The selected file must be a CSV, DOC, DOCM, DOCX, RTF, TXT, XLS, XLSM, XLSX, XLTM, XLTX, XLW or XML';
export const COMBINED_FILE_VALIDATION_MESSAGE = `The selected file must be a CSV, DOC, DOCM, DOCX, RTF, TXT, XLS, XLSM, XLSX, XLTM, XLTX, XLW or XML and must be smaller than ${MAX_SUPPORTING_FILE_SIZE_DISPLAY}MB`;

// User types
export const USER_TYPE_ADMIN = 'Admin';
export const USER_TYPE_STANDARD = 'User';
export const USER_GROUP_INTERNAL = 'Internal';
export const USER_GROUP_EXTERNAL = 'External';
export const INTERNAL_TEAMS = ['Border Force Team'];

// Emails
export const CENTRAL_EMAIL = 'BFCentralRCCGMteam@homeoffice.gov.uk';
export const NORTH_EMAIL = 'NorthGeneralAviationandMaritime@homeoffice.gov.uk';
export const SOUTH_EMAIL = 'BorderForceSouthGMteam@homeoffice.gov.uk';
export const SOUTH_EAST_EMAIL = 'BorderForceSouthEastGMteam@homeoffice.gov.uk';

// MISC
export const DECLARATION_ID_SESSION = 'declaration_id';
